module.exports = __webpack_public_path__ + "static/img/sk.11da0d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sjcw/sk.png
// module id = leCr
// module chunks = 26